import SocketIO from "socket.io-client";
import { Domain } from "../config/API";
let socketConnected;
let conn;
let isCreatingConnection;

async function ioConnect() {
  if (!conn) {
    conn = SocketIO(Domain);

    conn.connect();
  }

  if (conn && !socketConnected) {
    conn.connect();

    conn.on("connect", () => {
      console.log("WS connected");
      return true;
    });

    ////////////////////////\\\\\\\\\\\\\\\\\\\\\\\

    conn.on("disconnect", () => {
      isCreatingConnection = false;
    });
    socketConnected = true;
  }
}
const Socket = {
  ////////////////////////  General Chat \\\\\\\\\\\\\\\\\\\\\\\

  viewCard: (cardId) => conn?.emit("view-card", cardId),
  pageClosed: (logId) => conn?.emit("page-close", logId),

  ////////////////////////\\\\\\\\\\\\\\\\\\\\\\\

  checkConnection: () => conn?.connected,
  getSocket: () => conn,
  disconnectSocket: () => {
    if (conn) {
      conn.disconnect();
      isCreatingConnection = false;
      socketConnected = false;
    }
  },
  connect: () => {
    if (!isCreatingConnection) {
      conn && conn.disconnect();
      conn = null;
      socketConnected = false;
      isCreatingConnection = true;

      setTimeout(() => {
        ioConnect();
      }, 200);
      return true;
    }
  },
};

export { Socket };
